var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-module-ach-container"},[(_vm.paymentData)?_c('ach-item',{attrs:{"data":_vm.paymentData}}):_vm._e(),_c('div',{staticClass:"payment-module-ach-container__link",on:{"click":function($event){return _vm.$emit('changeSavedPayment', 'bluesnap_ach')}}},[_vm._v(" Change ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }